import { mapGetters } from 'vuex'
import users from './livechat-users'
import chatbox from './livechat-chatbox'
import api from '@/api'
import LivechatChattool from './livechat-chattool'
import Multiselect from 'vue-multiselect'

import LivechatPagelist from './livechat-pagelist'
import LivechatSearch from './LivechatSearch'
import LivechatSearchBox from './LivechatSearchBox'
import LivechatTab from './LivechatTab'

export default {
  components: {
    chatbox: chatbox,
    users: users,
    Multiselect,
    LivechatChattool,
    LivechatPagelist,
    LivechatSearch,
    LivechatSearchBox,
    LivechatTab,
  },
  data() {
    return {
      app: '',
      timer: '',
      type: 'admin',
      AdminID: localStorage.getItem('userid'),
      //type: 'bot', //ของเก่าก่อน แมมมอธ รับมาทำ
      tagOptions: [],
      allrentcustomer: [],
      allrentsupplier: [],
      usersearching: false,
      toolListHeight: 0,
      showSearch: false,
      openStartDate: false,
      openStartTime: false,
      openEndDate: false,
      openEndTime: false,
      input: {
        uuAreaName: '',
        search: '',
        uu_register_status: '',
        lastconversationfromdate: null,
        lastconversationtodate: null,
        lastconversationfromtime: null,
        lastconversationtotime: null,
        lastconversationfrom: null,
        lastconversationto: null,
        phoneno: null,
        uu_name: null,
        keyword: '',
        tags: [],
        status: null,
        app: '',
        session: '',
        assignadminname: '',
        realname: '',
        cardnumber: '',
        userListHeight: 0,
      },
      loading: false,
      newchatnotify: {}
    }
  },
  async created() {
    var vm = this

    if (vm.$store.state.livechat.filter.search) {
      vm.$store.state.livechat.filter.search = ''
    }

    if (vm.$route.query.user) {
      this.$store.commit('SET_LIVECHAT_TYPE', vm.$route.query.user == 'admin')
      //this.$store.commit('SET_LIVECHAT_TYPE', vm.$route.query.user == 'bot' ? 'bot' : 'admin') //ของเก่าก่อน แมมมอธ รับมาทำ
    }

    if (vm.$route.query.userid) {
      var userid = vm.$route.query.userid

      if (userid) {
        await vm.getUsersdata(userid).then(function(user) {
          if (user) {
            vm.selectedUser = {
              app: user.app,
              first_name: user.first_name,
              last_name: user.last_name,
              lastreply_time: null,
              profile_pic: user.profile_pic,
              session: '',
              sessionvalue: user.sessionvalue,
              userid: user.id,
              uu_areaname: null,
              type: user.context == 'contactadmin' ? 'admin' : ''
            }
          } else {
            vm.$swal({
              type: 'info',
              title: 'Not found this user'
            })
          }
        })
      }
    }

    if (this.selectedBot.theme == 'ticket') {
      this.$store.dispatch('loadAgents')
      this.$store.dispatch('loadAgentGroups')
      this.$store.dispatch('loadAgentSubGroups')
    }
    vm.livechatnotiunread()
    vm.timer = setInterval(() => {
      vm.livechatnotiunread()
    }, vm.$store.state.livechat.maxFatchUserTime)
  },
  beforeDestroy: function() {
    clearInterval(this.timer)
  },
  mounted: function() {
    var vm = this

    // if (['depa'].includes(vm.selectedBot.theme) || this.$route.query.app == 'line') {
    //   this.$store.commit('SET_LIVECHAT_APP', 'line')
    // } else {
    //   this.$store.commit('SET_LIVECHAT_APP', 'facebook')
    // }
    this.$store.commit('SET_LIVECHAT_APP', 'line')
  },
  computed: {
    isUnlock() {
      var bot = this.botlist.find(el => {
        return el.pageid == this.$store.state.livechat.pageid
      })
      if (!bot) return false
      return (
        (bot.pagetype == 'enterprise' && this.$store.state.livechatPageList.includes(bot.theme)) ||
        this.$store.state.livechatPageIdList.includes(bot.pageid) ||
        (bot.theme == 'ecommercebasic' && bot.pageid == '270028443161479') ||
        bot.isUnlockLivechat
      )
    },

    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist',
      searchlist: 'getLivechatSearching',
      selectedBot: 'selectedBot',
      livechatUsers: 'getLivechatUsers',
      selectedUser: 'getCurrentUser',
      searchlist: 'getLivechatSearching',
      agentGroup: 'getAgentGroup',
      agentSubGroup: 'getAgentSubgroup'
    }),

    selectedUser: {
      get() {
        return this.$store.state.livechat.currentUser
      },
      set(newVal) {
        this.$store.state.livechat.currentUser = newVal
      }
    },
    filter() {
      return this.$store.state.filter
    },
    areaname: function() {
      var area = this.$store.state.uuAreaName
      area.unshift('')
      return area
    }
  },
  methods: {
    onResizeUserList: function() {
      var vm = this
      vm.$nextTick(function() {
        if (document.getElementById('chattype')) {
          vm.userListHeight =
            window.innerHeight -
            document.getElementById('main_toolbar').clientHeight -
            document.getElementById('chattype').clientHeight -
            40
        }
      })
    },
    onUserScroll: async function() {
      var vm = this
      if (vm.isMobile) {
        return false
      }
      let messages = $('#users_' + vm.type)
      let scrollPosition = messages.scrollTop()
      let chatboxHeight = messages.outerHeight(true)
      let totalHeight = messages.prop('scrollHeight')

      if (scrollPosition <= chatboxHeight) {
        vm.enableAutoUpdate(true)
      }
      if (Math.abs(Math.round(scrollPosition + chatboxHeight) - totalHeight) < 3) {
        vm.enableAutoUpdate(false)
        await vm.onLoadmore()
      }
    },
    enableAutoUpdate: function(enable) {
      this.$set(this.$store.state.livechat.userlist[this.type], 'isAutoRefresh', enable)
    },
    onLoadmore: async function() {
      var vm = this
      if (vm.loadmore || !vm.$store.state.livechat.userlist[vm.type].hasMore) {
        return false
      }
      vm.loadmore = true

      vm.$set(
        vm.$store.state.livechat.userlist[vm.type],
        'limit',
        vm.$store.state.livechat.userlist[vm.type].limit + vm.$store.state.livechat.limitFatchUser
      )

      try {
        await vm.$store.dispatch('loadLivechatUsers', {
          type: vm.type
        })
        vm.loadmore = false
      } catch (error) {}
      finally {vm.loadmore = false}
    },


    
    imgError: function(event, el) {
      // console.log('not load')
      this.value.profile_pic = '/static/img/assets/livechat/profile.png'
    },
    changePage() {
      this.newchatnotify = {}
      this.selectedUser = null
    },
    deleteTag(index) {
      this.$store.state.livechat.filter.tags.splice(index, 1)
    },
    deleteTagNSearch(index) {
      this.$store.state.livechat.filter.tags.splice(index, 1)
      this.onSearch()
    },
    clearSearch() {
      this.input = {
        uuAreaName: '',
        search: '',
        uu_register_status: '',
        lastconversationfromdate: null,
        lastconversationtodate: null,
        lastconversationfromtime: null,
        lastconversationtotime: null,
        lastconversationfrom: null,
        lastconversationto: null,
        phoneno: null,
        uu_name: null,
        keyword: '',
        tags: [],
        status: null,
        app: '',
        realname: '',
        cardnumber: '',
      }
      this.onSearch()
    },
    onSearch() {
      localStorage.setItem('ReadFilter', false)
      localStorage.setItem('UnReadFilter', false)
      let vm = this
      vm.showSearch = false
      if (vm.input.lastconversationfromdate) {
        vm.input['lastconversationfrom'] =
          vm.input.lastconversationfromdate +
          (vm.input.lastconversationfromtime ? ' ' + vm.input.lastconversationfromtime : ' 00:00')
      } else {
        vm.input['lastconversationfrom'] = null
      }

      if (vm.input.lastconversationtodate) {
        vm.input['lastconversationto'] =
          vm.input.lastconversationtodate +
          (vm.input.lastconversationtotime ? ' ' + vm.input.lastconversationtotime : ' 23:59')
      } else {
        vm.input['lastconversationto'] = null
      }

      if (!vm.showSearch){
        vm.$store.commit('SET_LIVECHAT_FILTER', vm.input)
      }
      

      vm.usersearching = true
      vm.$nextTick(() => {
        vm.$store.dispatch('forceLoadLastestUsers').then(() => {
          vm.usersearching = false
        }).catch((error) => {
          console.log(error)
           vm.loading = false
           vm.usersearching = false
          }).finally (() => {
            vm.userloading = false
          })
        vm.$emit('input', false)
      })
    },
    addTag(newTag) {
      const tag = newTag
      this.tagOptions.push(tag)
      this.input.tags.push(tag)
    },

    livechatnotiunread() {
      api.livechatnotiunread({ pageid: this.$store.state.livechat.pageid }, (err, response) => {
        this.newchatnotify = response.data[0]
      })
    },
    getUsersdata: function(userid) {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = {
          userid: userid,
          pageid: vm.$store.state.livechat.pageid
        }

        api.getUsersdata(data, function(error, response) {
          if (error) {
            reject(error)
          }

          if (response.data) {
            resolve(response.data[0])
          } else {
            resolve(undefined)
          }
        })
      })
    },
    onEndSession: async function() {
      await this.endSession()
      this.$set(this.$store.state.livechat, 'currentUser', null)
      this.$store.dispatch('updateLivechatUser', null)
      this.$store.dispatch('forceLoadLastestUsers')
    },
    endSession: function() {
      let vm = this
      if (vm.selectedUser == null || vm.selectedBot == null) {
        return false
      }
      let data = {
        pageid: vm.$store.state.livechat.pageid,
        userid: vm.selectedUser.userid
      }
      return new Promise((resolve, reject) => {
        vm.$store.dispatch('loading')
        api.endSessionChat(data, function(error, response) {
          if (error) {
            vm.$store.dispatch('loading')
            reject(error)
          }

          vm.selectedUser = null

          vm.$store.dispatch('loading')
          resolve()
        })
      })
    },
    onOpenSession: async function() {
      await this.openSession()
      this.$store.commit('SET_LIVECHAT_TYPE', 'all')
      var user = this.$store.state.livechat.currentUser
      user.type = this.type
      this.$store.dispatch('updateLivechatUser', user)
      this.$store.dispatch('forceLoadLastestUsers')
      this.updateRoute()
    },
    openSession: function() {
      let vm = this

      if (vm.selectedUser == null || vm.selectedBot == null) {
        return false
      }
      let data = {
        pageid: vm.$store.state.livechat.pageid,
        userid: vm.selectedUser.userid
      }
      return new Promise((resolve, reject) => {
        vm.$store.dispatch('loading')
        api.openSessionChat(data, function(error, response) {
          if (error) {
            vm.$store.dispatch('loading')

            reject(error)
          }
          vm.$set(vm.selectedUser, 'type', 'admin')
          vm.$set(vm.selectedUser, 'context', 'contactadmin')
          vm.$store.commit('SET_LIVECHAT_USER', vm.selectedUser)

          vm.$store.dispatch('loading')
          resolve()
        })
      })
    },
    updateRoute: function() {
      var query = { ...this.$route.query }
      query.app = this.app
      query.user = this.type

      this.$router.push({
        name: 'allinonechat',
        path: '/allinonechat',
        query: query
      })
      this.routeValue = JSON.stringify(this.$route.query)
    },
    sendMessage: function(payload) {
      let vm = this
      let data = {
        pageid: vm.$store.state.livechat.pageid,
        userid: payload.data.user.userid,
        adminid: this.$store.state.userid,
        app: payload.data.app,
        messagetype: payload.data.type,
        messagevalue: payload.data.text,
        page_access_token: vm.selectedBot.page_access_token
      }
      let message = {
        answerby: 'admin',
        id: new Date().getTime(),
        messagedata: payload.data.text,
        messagetype: payload.data.type,
        pageid: vm.$store.state.livechat.pageid,
        timestamp: new Date(),
        userid: payload.data.user.userid
      }

      api.sendMessage(data, function(error, response) {
        if (error) {
          console.error(error)
          // vm.$store.dispatch('loading')
          return
        }
        // vm.$store.dispatch('loading')
      })
    }
  },
  watch: {
    selectedBot: function(newVal, oldVal) {
      if (newVal != oldVal) {
        var isCurrentUser = this.$store.state.livechat.currentUser

        if (isCurrentUser !== null && newVal.pageid !== this.$store.state.livechat.pageid) {
          this.$set(this.$store.state.livechat, 'currentUser', null)
        }
      }
    }
  }
}




// WEBPACK FOOTER //
// ./src/components/view/livechat/Livechat.js